import { Box, Grid, Typography } from "@mui/material";


export default function NoAddressScreen() {




  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        flexDirection="column"
        gap={2}
        px={{ xs: 2, sm: 5, md: 7, lg: 15 }}
      >
        <Box width={48} height={48}>
          <img src="/newdashboard/Checkout/Group 1171283823 (2).png" />
        </Box>
        <Typography
          textAlign="start"
          color="#572575"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="100%"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 700 }}
        >
         Welcome to your first Test Purchase!
        </Typography>

        <Typography
          textAlign="center"
          color="#555555"
          fontFamily="Inter"
          fontSize="14px"
          lineHeight="1.4"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 500 }}
        >
         Since this is your first purchase, please add a delivery address to <br/> complete your order.
        </Typography>

       
      </Box>


      
    </>
  );
}
